import { render } from "./CreateNewLeadModal.vue?vue&type=template&id=54937f58&ts=true"
import script from "./CreateNewLeadModal.vue?vue&type=script&lang=ts"
export * from "./CreateNewLeadModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__